import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { FlamingoAuthService } from './flamingo-auth.service';

@Injectable()
export class FlamingoAuthGuard implements CanActivate {

    constructor(
        private authService: FlamingoAuthService,
        private router: Router
    ) {
    }

    canActivate(): boolean {
        if (this.authService.isLogged()) {
            return true;
        } else {
            this.router.navigate(['/auth']);
            return false;
        }
    }
}
